import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-page"
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#0F172A',
            color: '#fff',
            fontFamily: '"Barlow Condensed", "Manrope", system-ui, sans-serif',
            padding: '24px',
          }}
        >
          <div style={{ textAlign: 'center', maxWidth: 440 }}>
            {/* Logo iBookSport */}
            <img
              src="/logo-light.png"
              alt="iBookSport"
              style={{ height: 48, marginBottom: 32, display: 'inline-block' }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />

            {/* Icon */}
            <div
              style={{
                width: 64,
                height: 64,
                background: 'rgba(255, 69, 0, 0.15)',
                border: '2px solid #FF4500',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 24,
              }}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FF4500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>

            <h2
              style={{
                fontSize: 22,
                fontWeight: 800,
                marginBottom: 8,
                fontFamily: '"Barlow Condensed", sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
            >
              Une erreur est survenue
            </h2>

            <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 32, lineHeight: 1.6, fontFamily: '"Manrope", sans-serif' }}>
              Nous nous excusons pour ce desagrement. Veuillez rafraichir la page pour continuer votre experience sur iBookSport.
            </p>

            <button
              data-testid="error-refresh-btn"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              style={{
                background: '#FF4500',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                fontWeight: 700,
                cursor: 'pointer',
                textTransform: 'uppercase',
                fontSize: 13,
                letterSpacing: '1px',
                fontFamily: '"Barlow Condensed", sans-serif',
                transition: 'background 0.2s',
              }}
              onMouseOver={(e) => (e.target.style.background = '#e03e00')}
              onMouseOut={(e) => (e.target.style.background = '#FF4500')}
            >
              Rafraichir la page
            </button>

            {/* Error details — always visible to help diagnose issues quickly */}
            {this.state.error && (
              <details style={{ marginTop: 24, textAlign: 'left', background: '#1e293b', padding: 12, borderRadius: 4, border: '1px solid rgba(148,163,184,0.2)' }}>
                <summary style={{ color: '#fbbf24', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: '"Manrope", sans-serif' }}>
                  Details techniques (cliquez pour developper)
                </summary>
                <pre style={{ color: '#fca5a5', fontSize: 11, marginTop: 8, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'monospace', lineHeight: 1.4, maxHeight: 280, overflow: 'auto' }}>
                  {String(this.state.error?.toString?.() || this.state.error)}
                  {this.state.error?.stack && '\n\n' + this.state.error.stack}
                </pre>
              </details>
            )}

            <div style={{ marginTop: 32, borderTop: '1px solid rgba(148, 163, 184, 0.15)', paddingTop: 16 }}>
              <p style={{ color: '#475569', fontSize: 11, fontFamily: '"Manrope", sans-serif' }}>
                www.ibooksport.com
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
